<template>
  <div class="infoPage">
    <Header :isShow="false"></Header>
    <div class="bg">
      <div class="info-box">
        <div class="one-text text-color">Personal Information</div>
        <!-- <div class="two-text text-color">First Name</div>
      <el-input class="input" placeholder="First Name"></el-input>
      <div class="three-text text-color">Last Name</div>
      <el-input class="input" placeholder="Last Name"></el-input> -->

        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="form"
          :hide-required-asterisk="true"
          :label-position="right"
        >
          <div class="two-text text-color">Name</div>
          <el-form-item prop="firstName" class="item">
            <el-input
              v-model="ruleForm.firstName"
              class="input"
              placeholder="Name"
            ></el-input>
          </el-form-item>
          <!-- <div class="three-text text-color">Last Name</div>
          <el-form-item prop="lastName">
            <el-input
              v-model="ruleForm.lastName"
              class="input"
              placeholder="Last Name"
            ></el-input>
          </el-form-item> -->
        </el-form>
        <el-button class="btn" @click="comfirmDo('ruleForm')"
          >Confirm</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import { ElMessage } from "element-plus";
import { patchUser, getUserById } from "@/request/api";
export default {
  name: "infoPage",
  data() {
    return {
      ruleForm: {
        firstName: "",
        // lastName: "",
      },
      rules: {
        firstName: [
          {
            required: true,
            message: "please enter Name",
            trigger: "blur",
          },
        ],
        // lastName: [
        //   {
        //     required: true,
        //     message: "please enter Last Name",
        //     trigger: "blur",
        //   },
        // ],
      },
    };
  },
  methods: {
    async comfirmDo(formName) {
      // this.$router.push({ name: "Home"})
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitDo();
          return true;
        } else {
          return false;
        }
      });
    },

    async submitDo() {
      const info = {
        email: this.ruleForm.email,
        name: this.ruleForm.firstName,
        organization: this.ruleForm.organization,
        jobtitle: this.ruleForm.jobtitle,
        phone: this.ruleForm.phone,
        countryCode: this.ruleForm.countryCode
      };
      try {
        await patchUser(info);
        ElMessage("update success");
        this.$router.push({ name: "Home" });
      } catch (error) {
        ElMessage.error("update fail");
      }
    },
  },
  async created() {
    const userInfo = await getUserById();
    console.log(userInfo)
    this.ruleForm.firstName = userInfo.user?.nickname
    this.ruleForm.email = userInfo.user?.email
    this.ruleForm.organization = userInfo.user?.profile?.company.value
    this.ruleForm.jobTitle = userInfo.user?.profile?.jobtitle?.value;
    this.ruleForm.phone = userInfo.user?.phone?.phone
    this.ruleForm.countryCode = userInfo.user?.phone?.countrycode
    if (userInfo?.user?.nickname) {
      this.$router.push({ name: "Home" })
    }

  },
  components: {
    Header,
  },
};
</script>
<style lang='less' scoped>
.infoPage {
  width: 100vw;
  height: 100vh;
  background-color: red;
  background-image: url(../assets/info-page.jpg);
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.bg {
  width: 100vw;
  height: calc(100vh - 102px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-box {
  // margin: 0 auto;
  background-color: #fff;
  width: 600px;
  height: 350px;
  // border: 1px solid #707070;
  // margin-top: 400px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 5px #e1efff;
}

.form {
  margin-left: 100px;
  width: 400px;
  // background-color: red;
}

.text-color {
  color: #565656;
  text-align: left;
  // margin-left: 90px;
}

.one-text {
  font-size: 28px;
  font-weight: 400;
  margin-top: 40px;
  margin-left: 100px;
}

.two-text {
  font-size: 16px;
  font-weight: 400;
  margin-top: 20px;
}

.three-text {
  font-size: 16px;
  font-weight: 400;
  // margin-top: 5px;
}

.input {
  width: 400px;
  height: 48px;
  // margin-left: 90px;
  margin-top: 10px;
}

.btn {
  width: 400px;
  height: 54px;
  background-color: #0050b3;
  font-size: 20px;
  color: #fff;
  margin-left: 100px;
  margin-top: 30px;
}
</style>